const REFERRAL_STORAGE_KEY = 'referralCodeV2';

const TERMINAL_REFERRAL_STATUSES = [
  'attached',
  'already_attached',
  'invalid',
  'self_referral',
  'referrer_not_found',
  'unknown',
  'inactive',
];

const getStore = (storage) => storage || (typeof localStorage === 'undefined' ? null : localStorage);

const normalizeReferralCode = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

const extractReferralCodeFromQuery = (query) => {
  if (!query || typeof query !== 'object' || Array.isArray(query)) {
    return null;
  }

  return normalizeReferralCode(query.i);
};

const storeReferralCode = (value, storage) => {
  const store = getStore(storage);
  const code = normalizeReferralCode(value);

  if (!store || !code) {
    return null;
  }

  store.setItem(REFERRAL_STORAGE_KEY, code);
  return code;
};

const getStoredReferralCode = (storage) => {
  const store = getStore(storage);
  if (!store) {
    return null;
  }

  return normalizeReferralCode(store.getItem(REFERRAL_STORAGE_KEY));
};

const getReferralPayloadFromStorage = (storage) => {
  const code = getStoredReferralCode(storage);
  if (!code) {
    return {};
  }

  return { referral_code: code };
};

const hasReferralPayload = (payload) => Boolean(
  payload && normalizeReferralCode(payload.referral_code)
);

const parseReferralStatus = (body) => {
  if (!body || typeof body !== 'object' || Array.isArray(body)) {
    return null;
  }

  const status = body.referral_status || body.status;
  return typeof status === 'string' ? status : null;
};

const shouldClearStoredReferral = (status) => TERMINAL_REFERRAL_STATUSES.indexOf(status) !== -1;

const applyReferralProcessingResult = (body, storage) => {
  const store = getStore(storage);
  const status = parseReferralStatus(body);
  if (shouldClearStoredReferral(status) && store) {
    store.removeItem(REFERRAL_STORAGE_KEY);
  }
  return status;
};

const isServerErrorStatus = (httpStatus) => typeof httpStatus === 'number' && httpStatus >= 500;

const submitStoredReferral = async ({
  post,
  storage,
  isAuthenticated = false,
}) => {
  const store = getStore(storage);
  const payload = getReferralPayloadFromStorage(store);
  if (!hasReferralPayload(payload)) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  try {
    const response = await post('/user/referral', payload);
    return applyReferralProcessingResult(response && response.data, store);
  } catch (error) {
    const httpStatus = error && error.response && error.response.status;
    if (isServerErrorStatus(httpStatus)) {
      throw error;
    }

    const status = applyReferralProcessingResult(
      error && error.response && error.response.data,
      store
    );
    if (shouldClearStoredReferral(status)) {
      return status;
    }
    throw error;
  }
};

const resolveUserReferralLink = (userProfile, origin) => {
  if (!userProfile || typeof userProfile !== 'object') {
    return '';
  }

  const backendLink = typeof userProfile.referralLink === 'string'
    ? userProfile.referralLink.trim()
    : '';
  if (backendLink) {
    return backendLink;
  }

  const code = normalizeReferralCode(userProfile.referralCode);
  if (!code) {
    return '';
  }

  let base = typeof origin === 'string' ? origin : '';
  if (!base && typeof window !== 'undefined' && window.location) {
    base = window.location.origin;
  }

  return base + '/?i=' + encodeURIComponent(code);
};

exports.__esModule = true;
exports.REFERRAL_STORAGE_KEY = REFERRAL_STORAGE_KEY;
exports.TERMINAL_REFERRAL_STATUSES = TERMINAL_REFERRAL_STATUSES;
exports.extractReferralCodeFromQuery = extractReferralCodeFromQuery;
exports.normalizeReferralCode = normalizeReferralCode;
exports.storeReferralCode = storeReferralCode;
exports.getStoredReferralCode = getStoredReferralCode;
exports.getReferralPayloadFromStorage = getReferralPayloadFromStorage;
exports.hasReferralPayload = hasReferralPayload;
exports.parseReferralStatus = parseReferralStatus;
exports.shouldClearStoredReferral = shouldClearStoredReferral;
exports.applyReferralProcessingResult = applyReferralProcessingResult;
exports.submitStoredReferral = submitStoredReferral;
exports.resolveUserReferralLink = resolveUserReferralLink;
